// @ts-nocheck
import "../advanced.scss";
import DateWrapper from "atoms/datePicker/datePicker";
import TextInput from "atoms/TextInput/textInput";
import _ from "lodash";
import Stack from "molecules/stack/stack";
import StackItem from "molecules/stackItem/stackItem";
import MultiSelectDropdown from "organisms/multiSelect/multiSelect";
import { useState, useEffect } from "react";

const SearchInputBox = (props) => {
  const { currentSearchInput, handleSubmit, onUpdateInput, disabled, type } =
    props;
  const [rawValue, setRawValue] = useState("");

  useEffect(() => {
    if (!currentSearchInput) {
      setRawValue("");
      return;
    }

    const quotedMatches = currentSearchInput.match(/'[^']*'/g);

    if (quotedMatches?.length) {
      const parsed = quotedMatches.map((v) => v.slice(1, -1)).join(", ");
      setRawValue(parsed);
    } else {
      setRawValue(currentSearchInput); // fallback to raw if not quoted
    }
  }, [currentSearchInput]);

  const onChange = (e) => {
    const input = e.target.value;
    setRawValue(input);

    const quoted = input
      .split(",")
      .map((v) => v.trim())
      .filter(Boolean)
      .map((v) => `${v}`);

    onUpdateInput({
      target: { value: quoted.length > 1 ? `${input}` : quoted.join(",") },
    });
  };

  return (
    <TextInput
      value={rawValue}
      onKeyDown={_.debounce(handleSubmit, 500)}
      onChange={onChange}
      disabled={disabled}
      type={type}
    />
  );
};

const MultiSelectConfig = (props) => {
  const {
    isOperatorBtwn,
    isOperatorBoolean,
    currentSearchInput,
    isOperatorIn,
    isOperatorBulkIn,
    selectedCriteria,
    currentSearchInputEnd,
    onUpdateModel,
    updateCurrentSearchInputEnd,
    updateCurrentSearchInput,
    selectionProviderOptions,
    isOperatorDate,
    isEqualsOperator,
    onUpdateInput,
    isOperatorEmpty,
    handleSubmit,
    isInline,
    columnData,
  } = props;

  if (isOperatorBulkIn) {
    return (
      <StackItem isStretch isGrow position="center">
        <MultiSelectDropdown
          {...props}
          componentId={"select-" + columnData.AppColumnName}
          key={"select-start-" + columnData.AppColumnName}
          onChange={(e) => {
            onUpdateInput(e);
            handleSubmit(null, true, {
              currentSearchInput: e.target.value,
            });
          }}
          isInline={isInline}
          selection={currentSearchInput}
          columnName={columnData.AppColumnName}
          type="textarea"
        />
      </StackItem>
    );
  }

  if (isOperatorDate) {
    return (
      !isOperatorEmpty && (
        <StackItem isStretch isGrow position="center">
          <DateWrapper
            selectedDate={
              isOperatorBtwn
                ? [currentSearchInput, currentSearchInputEnd]
                : currentSearchInput
            }
            allowEmpty
            handleClick={(e) => onUpdateModel({ dateEvent: e })}
            isRange={isOperatorBtwn}
          />
        </StackItem>
      )
    );
  }
  if (isOperatorIn) {
    return (
      <StackItem span={2}>
        <Stack gutter="small">
          <StackItem isStretch isGrow>
            <MultiSelectDropdown
              {...props}
              componentId={"select-" + columnData.AppColumnName}
              key={"select-" + columnData.AppColumnName}
              onChange={(e) => {
                onUpdateInput(e);
                handleSubmit(null, true, {
                  currentSearchInput: e.target.value,
                });
              }}
              isInline={isInline}
              selection={currentSearchInput}
              selectionProviderOptions={selectionProviderOptions}
              columnName={columnData.AppColumnName}
            />
          </StackItem>
        </Stack>
      </StackItem>
    );
  }

  if (isEqualsOperator) {
    return (
      <StackItem isStretch isGrow position="center">
        <Stack gutter="small">
          <StackItem isStretch isGrow>
            <MultiSelectDropdown
              {...props}
              componentId={"select-" + columnData.AppColumnName}
              key={"select-start-" + columnData.AppColumnName}
              onChange={(e) => {
                onUpdateInput(e);
                handleSubmit(null, true, {
                  currentSearchInput: e.target.value,
                });
              }}
              isInline={isInline}
              isSingleSelect
              selection={currentSearchInput}
              selectionProviderOptions={selectionProviderOptions}
              columnName={columnData.AppColumnName}
            />
          </StackItem>
        </Stack>
      </StackItem>
    );
  }

  if (isOperatorBtwn) {
    return (
      <>
        <StackItem isStretch isGrow position="center">
          <TextInput
            value={currentSearchInput}
            onKeyDown={_.debounce(handleSubmit, 500)}
            type={selectedCriteria.type}
            onChange={onUpdateInput}
          ></TextInput>
        </StackItem>
        <StackItem isStretch isGrow position="center">
          <TextInput
            value={currentSearchInputEnd}
            onKeyDown={_.debounce(handleSubmit, 500)}
            type={selectedCriteria.type}
            onChange={(e) => updateCurrentSearchInputEnd(e.target.value)}
          ></TextInput>
        </StackItem>{" "}
      </>
    );
  }

  if(isOperatorBoolean){
    return <></>
  }

  return (
    <StackItem isStretch isGrow position="center">
      <SearchInputBox
        handleSubmit={handleSubmit}
        disabled={isOperatorEmpty}
        currentSearchInput={currentSearchInput}
        onUpdateInput={onUpdateInput}
        type={selectedCriteria.type}
      />
    </StackItem>
  );
};

const DefaultConfig = ({
  isOperatorBtwn,
  currentSearchInput,
  isOperatorIn,
  currentSearchInputEnd,
  isOperatorDate,
  isOperatorBulkIn,
  isOperatorEmpty,
  selectedCriteria,
  onUpdateModel,
  onUpdateInput,
  handleSubmit,
}) => {
  if (isOperatorDate) {
    return (
      <StackItem isStretch isGrow position="center">
        <DateWrapper
          selectedDate={
            isOperatorBtwn
              ? [currentSearchInput, currentSearchInputEnd]
              : currentSearchInput
          }
          allowEmpty
          handleClick={(e) => onUpdateModel({ dateEvent: e })}
          isRange={isOperatorBtwn}
        />
      </StackItem>
    );
  }

  if (isOperatorBtwn) {
    return (
      <>
        <StackItem isStretch isGrow position="center">
          <TextInput
            value={currentSearchInput}
            onKeyDown={_.debounce(handleSubmit, 500)}
            onChange={onUpdateInput}
            type={isOperatorIn ? "text" : selectedCriteria.type}
          ></TextInput>
        </StackItem>
        <StackItem isStretch isGrow position="center">
          <TextInput
            value={currentSearchInputEnd}
            onKeyDown={_.debounce(handleSubmit, 500)}
            type={selectedCriteria.type}
            onChange={(e) => updateCurrentSearchInputEnd(e.target.value)}
          ></TextInput>
        </StackItem>{" "}
      </>
    );
  }
  return (
    <StackItem isStretch isGrow position="center">
      <SearchInputBox
        handleSubmit={handleSubmit}
        disabled={isOperatorEmpty}
        currentSearchInput={currentSearchInput}
        onUpdateInput={onUpdateInput}
        type={selectedCriteria.type}
      />
    </StackItem>
  );
};
const agGridSelectColumnDefinitions = {
  DEFAULT_CONFIG: {
    getTemplate: (props) => {
      return <DefaultConfig {...props} />;
    },
  },
  MULTISELECT_CONFIG: {
    getTemplate: (props) => {
      return <MultiSelectConfig {...props} />;
    },
  },
};

export default agGridSelectColumnDefinitions;
